// Tax-exempt items from Grand Exchange
// These items are exempt from the 2% convenience fee
// Source: https://oldschool.runescape.wiki/w/Grand_Exchange#Tax_exempt_items

export const taxExemptItems = new Set([
    // Old school bonds
    'Old school bond',
    
    // Energy potion (all doses)
    'Energy potion',
    'Energy potion(1)',
    'Energy potion(2)',
    'Energy potion(3)',
    'Energy potion(4)',
    
    // Low level combat consumables
    'Bronze arrow',
    'Bronze dart',
    'Iron arrow',
    'Iron dart',
    'Mind rune',
    'Steel arrow',
    'Steel dart',
    
    // Low level food
    'Bass',
    'Bread',
    'Cake',
    'Cooked chicken',
    'Cooked meat',
    'Herring',
    'Lobster',
    'Mackerel',
    'Meat pie',
    'Pike',
    'Salmon',
    'Shrimps',
    'Tuna',
    
    // Teleport items
    'Ardougne teleport',
    'Ardougne teleport (tablet)',
    'Camelot teleport',
    'Camelot teleport (tablet)',
    'Civitas illa fortis teleport',
    'Civitas illa fortis teleport (tablet)',
    'Falador teleport',
    'Falador teleport (tablet)',
    'Games necklace(8)',
    'Kourend castle teleport',
    'Kourend castle teleport (tablet)',
    'Lumbridge teleport',
    'Lumbridge teleport (tablet)',
    'Ring of dueling(8)',
    'Teleport to house',
    'Teleport to house (tablet)',
    'Varrock teleport',
    'Varrock teleport (tablet)',
    
    // Tools
    'Chisel',
    'Gardening trowel',
    'Glassblowing pipe',
    'Hammer',
    'Needle',
    'Pestle and mortar',
    'Rake',
    'Saw',
    'Secateurs',
    'Seed dibber',
    'Shears',
    'Spade',
    'Watering can (0)'
]);

